<div [ngStyle]="{ height: (height ? height : '420') + 'px', width: '100%' }">
	<canvas
		#chartCanvas
		[id]="uuid"
		[ngStyle]="{ minWidth: '100%', height: (height ? height - 35 : '385') + 'px' }"
	></canvas>
</div>
